import React from 'react';

const ArrowButtonHorz = (props) => {
    const { direction, radio } = props;

    let arrow = '';
    if (direction == 'gauche') {
        arrow = '<';
    } else if (direction == 'droite') {
        arrow = '>';
    } else {
        console.error('ArrowButtonHorz =' + direction);
    }

    return (
        <button
            type="button"
            className={'btn_tel_fleche btn_fleche_horz btn_fleche_' + direction}
            onClick={() => radio.pressButton(direction)}
        >
            {arrow}
        </button>
    );
};

export default ArrowButtonHorz;
